import Vue from 'vue';
export default Vue.extend({
    name: 'customIcon',
    props: {
        color: {
            type: String,
            default: '#ffffff'
        },
        fontWeight: {
            type: String,
            default: '400'
        },
        fontSize: {
            type: String,
            default: '14px'
        }
    }
});
